var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.screenType === 'desktop')?_c('home-desktop'):(_vm.screenType ==='mobile')?_c('home-mobile'):_c('home-tablet')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }